import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptTermsAndConditions } from '@/apis/tass-api/user';

export const useAcceptTermsAndConditions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptTermsAndConditions,
    onSuccess: () => {
      // Invalidate and refetch user data to get updated termsAndConditionsAcceptedAt
      queryClient.invalidateQueries({ queryKey: ['user_mine_sdk'] });
      toast.success('Terms and conditions accepted');
    },
    onError: (error) => {
      console.error('Failed to accept terms and conditions:', error);
      toast.error('Failed to accept terms and conditions. Please try again.');
    },
  });
};
